import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { HttpModule  } from '@angular/http';
import {AppComponent} from './app.component';
import {ModelModule} from './model/model.module';
import {AuditModule} from './search/search.module';
import { AppRoutingModule } from './app-routing.module';
import {ToplineComponent} from './search/top-line/topline.component';




@NgModule({
  declarations: [
    AppComponent
  ],
   imports: [
     BrowserModule,
     FormsModule,
     HttpModule,
     ModelModule,
     AuditModule,
     AppRoutingModule,
   ],
   bootstrap:    [ AppComponent ]
})
export class AppModule { }






// WEBPACK FOOTER //
// C:/Проекты/grant_results/src/app/app.module.ts